import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../ReusableComponent/CIVIL/CivilTestToggle/Toggle.css'; // You can create a CSS file for styling
// import Modal from 'react-modal';
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';



function SectionIATestList({ tests, loadingTests, CUET_SubjectType, enrolled }) {
    console.log(tests, loadingTests);
    const location = useLocation();
    // packageid, Accesscode, Duration, MarksTotal, QuestionCount
    const [activeIndex, setActiveIndex] = useState(null);

    // const [testSeriesTests, setTestSeriesTests] = useState(tests)

    const storedAuthToken = localStorage.getItem('authtoken');


    const toggleState = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (CUET_SubjectType == 'Please select subject') {
        return <div className='card p-2 my-4 mx-2 shadow-lg'>
            <h1 className='fs-6 text-center m-2 text-info'>Please select any Section-IA subject to load tests</h1>
        </div>
    }

    if (loadingTests) {
        return <div className="pt-4 d-flex flex-column align-items-center justify-content-center">
            <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <h4 className="fw-bold text-secondary">Getting your tests ready...</h4>
            <p className="text-muted">Please wait while we load the tests.</p>
        </div>

    }
    if (tests.length < 1 && !loadingTests) {
        return <>
            <div className='card p-2 my-4 mx-2 shadow-lg'>
                <h1 className='fs-6 text-center m-2 text-danger'>Tests are not availbale</h1>
            </div>
        </>
    }

    return (
        <>
            <div className='card p-2 my-4 mx-2 shadow-lg'>
                {tests?.map((testData, index) => (
                    <div key={index} className="d-grid gap-1 m-1 test-togglebackground">
                        <button onClick={() => toggleState(index)} className="toggle-button py-2 d-flex justify-content-between">
                            <div className="text-nowrap me-2">
                                Test-{index + 1}
                            </div>
                            <div className=' me-3 mt-0'>
                                <h1 className='fs-6'>{CUET_SubjectType}</h1>
                            </div>
                            <div className=' me-3 mt-0'>
                                < Link to='/StudentDashboard' state={{ prePath: location.pathname }} className={`list-group-item p-1 fw-bold bg-pureorange test-btn ${enrolled ? "" : 'disable'} text-white`}>
                                    TAKE TEST
                                </Link >
                            </div>
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
}

export default SectionIATestList;

